import { AssetManager } from "../AssetManager";
import { Game } from "../logic/Game";
import { GameView } from "./GameView";

export class GameUiView {
    public constructor(
        public game: Game,
        protected assets: AssetManager,
        protected game_view: GameView,
        protected context: CanvasRenderingContext2D,
    ) {

    }

    public update() {
        this.context.font = "12px monospace";
        this.context.textAlign = "left";
        this.context.textBaseline = "top";
        this.context.fillStyle = "white";
        this.context.fillText("Wave ", 165, 20);
        this.context.fillText(this.game.wave_counter.toString(), 165, 30);
        this.context.fillText("Lives ", 165, 50);
        this.context.fillText(this.game.lives.toString(), 165, 60);
        this.context.fillText("Money ", 165, 80);
        this.context.fillText(this.game.money.toString(), 165, 90);

        this.context.strokeStyle = "black";
        const [x, y] = this.game.ui.selected_field.position;

        this.context.strokeRect(
            x * this.game_view.field_width,
            y * this.game_view.field_height,
            this.game_view.field_width,
            this.game_view.field_height
        )
    }
}